// eslint-disable-next-line
import { h, Component } from 'preact';
import { MOBILE_WIDTH_MEDIA_QUERY } from '../../consts';

class BindToElement extends Component {
    state = {
        isMobile: false,
        x: 0,
        y: 0,
        screenW: window.innerWidth,
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
        this.mql = window.matchMedia(MOBILE_WIDTH_MEDIA_QUERY);
        this.mql.addListener(this.handleMediaQueryWidth);
        this.handleMediaQueryWidth();
        this.handleWindowResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.mql.removeEventListener(this.handleMediaQueryWidth);
    }

    handleWindowResize = () => {
        this.positionChildren();
    };

    handleMediaQueryWidth = ev => {
        const isMobile = ev ? ev.matches : window.matchMedia(MOBILE_WIDTH_MEDIA_QUERY).matches;

        this.setState({ isMobile });
    };

    positionChildren = () => {
        if (window.innerWidth === this.state.screenW && this.state.x !== 0 && this.state.y !== 0) return;

        const { elementSelector } = this.props;

        const bindEl = document.querySelector(elementSelector);

        if (!bindEl) {
            throw new Error(`Cannot find element to bind to (${elementSelector})`);
        }

        const rect = bindEl.getBoundingClientRect(bindEl);

        const x = rect.left + Math.round(rect.width / 2);
        const y = rect.top + rect.height;

        this.setState({ x, y, screenW: window.innerWidth });
    };

    render() {
        return this.props.children[0](this.state);
    }
}

export default BindToElement;
